// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle[data-v-5d97dbe5]{border-radius:50%}", ""]);
// Exports
module.exports = exports;
